module.exports = __webpack_public_path__ + "img/logo-mwe-full.49a23044.png";